module.exports = __webpack_public_path__ + "static/browser_wahl-7d79a297870749ed100505073456b0bc.png";